import Cookies from 'js-cookie';
import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response interceptor: persist rotated tokens + handle 401
  wootApi.interceptors.response.use(
    response => {
      const accessToken = response.headers['access-token'];
      if (accessToken && response.headers.client && response.headers.uid) {
        Cookies.set(
          'cw_d_session_info',
          JSON.stringify({
            'access-token': accessToken,
            'token-type': response.headers['token-type'] || 'Bearer',
            client: response.headers.client,
            expiry: response.headers.expiry,
            uid: response.headers.uid,
          }),
          { expires: 14 }
        );
        Object.assign(wootApi.defaults.headers.common, {
          'access-token': accessToken,
          'token-type': response.headers['token-type'] || 'Bearer',
          client: response.headers.client,
          expiry: response.headers.expiry,
          uid: response.headers.uid,
        });
      }
      return response;
    },
    error => {
      if (error?.response?.status === 401) {
        const currentPath = window.location.pathname;
        if (
          !currentPath.includes('/auth') &&
          !currentPath.includes('/app/login')
        ) {
          clearCookiesOnLogout();
        }
      }
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
